import React from "react";
import { Link, useLocation } from "react-router-dom";
import homeIcon from "../assets/images/home-icon.svg";
import quicklookIcon from "../assets/images/quick-look.svg";
import insuranceIcon from "../assets/images/insurance.svg";
import financeIcon from "../assets/images/finance.svg";
import pensionIcon from "../assets/images/pension.svg";
import retirementIcon from "../assets/images/retirement.svg";
import loansIcon from "../assets/images/loans.svg";
import attractionIcon from "../assets/images/attraction.svg";
import savingsIcon from "../assets/images/savings.svg";

const Sidebar = () => {
  const location = useLocation();

  const isActive = (path) => (location.pathname === path ? "active" : "");

  return (
    <div className="sidebar">
      <div className="sidebar-home">
        <Link to="/" className={`d-flex align-items-center justify-content-center`}>
          <span className="icon">
            <img src={homeIcon} alt="Home Icon" />
          </span>
        </Link>
      </div>
      <ul className="sidebar-nav">
        {/* <li>
          <Link className={`d-flex flex-column align-items-center ${isActive("/profile")}`} to="/profile">
            <span className="icon"><img src={attractionIcon} alt="Attraction Icon" /></span>
            <span className="link-title">פרופיל</span>
          </Link>
        </li> */}
        <li>
          <Link className={`d-flex flex-column align-items-center ${isActive("/summary-page")} ${isActive("/")}`} to="/summary-page">
            <span className="icon">
              <img src={quicklookIcon} alt="Quick Look Icon" />
            </span>
            <span className="link-title">מבט מהיר</span>
          </Link>
        </li>
        <li>
          <Link className={`d-flex flex-column align-items-center ${isActive("/recommendations")}`} to="/recommendations">
            <span className="icon"><img src={savingsIcon} alt="Savings Icon" /></span>
            <span className="link-title">המלצות</span>
          </Link>
        </li>
        <li>
          <Link className={`d-flex flex-column align-items-center ${isActive("/active-insurance")}`} to="/active-insurance">
            <span className="icon">
              <img src={insuranceIcon} alt="Insurance Icon" />
            </span>
            <span className="link-title">ביטוח</span>
          </Link>
        </li>
        <li>
          <Link className={`d-flex flex-column align-items-center ${isActive("/finance")}`} to="/finance">
            <span className="icon">
              <img src={financeIcon} alt="Finance Icon" />
            </span>
            <span className="link-title">פיננסים</span>
          </Link>
        </li>
        <li>
          <Link className={`d-flex flex-column align-items-center ${isActive("/pension-policy")}`} to="/pension-policy">
            <span className="icon">
              <img src={pensionIcon} alt="Pension Icon" />
            </span>
            <span className="link-title">פנסיה</span>
          </Link>
        </li>
        <li>
          <Link className={`d-flex flex-column align-items-center ${isActive("/retirement")}`} to="/retirement">
            <span className="icon"><img src={retirementIcon} alt="Retirement Icon" /></span>
            <span className="link-title">פרישה</span>
          </Link>
        </li>
        {/* <li>
          <Link className={`d-flex flex-column align-items-center ${isActive("/get-money")}`} to="/get-money">
            <span className="icon"><img src={attractionIcon} alt="Attraction Icon" /></span>
            <span className="link-title">משיכה</span>
          </Link>
        </li> */}
        <li>
          <Link className={`d-flex flex-column align-items-center ${isActive("/loans")}`} to="/loans">
            <span className="icon"><img src={loansIcon} alt="Loans Icon" /></span>
            <span className="link-title">הלוואות</span>
          </Link>
        </li>
        <li>
          <Link className={`d-flex flex-column align-items-center ${isActive("/savings")}`} to="/savings">
            <span className="icon"><img src={savingsIcon} alt="Savings Icon" /></span>
            <span className="link-title">חיסכון</span>
          </Link>
        </li>
        
        {/* <li>
          <Link className={`d-flex flex-column align-items-center ${isActive("/loading")}`} to="/loading">
            <span className="icon"><img src={attractionIcon} alt="Attraction Icon" /></span>
            <span className="link-title">משיכה</span>
          </Link>
        </li> */}
      </ul>
    </div>
  );
};

export default Sidebar;
